import { useTranslations } from 'next-intl';
import {
  ContentLayout,
  GlobalPageContent,
} from '@silvertours/common-landingpages-view';
import {
  BenefitsLegacy,
  ContentArticle,
  StageLegacy,
} from '@silvertours/front-features';

import { Body } from '../body';

const GlobalContent = ({
  content: {
    globalRating,
    links,
    stage,
    textContent: { primaryHeadline },
  },
  ...commonProps
}: ContentLayout<GlobalPageContent>) => {
  const t = useTranslations('features');
  const translations = t.raw('article' as any);

  return (
    <Body
      variant={{ kind: 'default' }}
      title={primaryHeadline}
      bodyTop={
        <StageLegacy.Stage
          content={stage.content}
          headline={primaryHeadline}
          variant={{ kind: 'default' }}
        />
      }
      searchData={stage?.content?.search}
      content={({ containerModule }) => [
        containerModule(
          'usp',
          <BenefitsLegacy.Usp rating={globalRating.content} />,
        ),

        containerModule(
          'linkLists',
          <ContentArticle
            modules={links.content ?? []}
            translations={translations}
          />,
          !!links.content.length,
        ),
      ]}
      {...commonProps}
    />
  );
};

export { GlobalContent };
